// extracted by css-extract-rspack-plugin
export default {"menu":"Wue2MkFP6xwtlDPq"};